import { JustificativaModal } from '@components/Modal/JustificativaModal';
import { IForm } from '@hooks/useForm';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IJustificativaRequest } from '@hooks/useRequest';
import IFatura from '@model/Fatura';
import { useFaturaService } from '@services/FaturaService';
import { AxiosResponse } from 'axios';
import React from 'react';

export type FaturaCancelarModalProps = {
    modal: IModalWindow
    fatura: IFatura
    onFaturaCancelada: (response: AxiosResponse<IFatura>) => void
}

export function FaturaCancelarModal ({ modal, fatura, onFaturaCancelada }: FaturaCancelarModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const faturaService = useFaturaService();

    const handleConfirm = React.useCallback((values: IJustificativaRequest, form: IForm<IJustificativaRequest>)  => {
        if (!loading.isLoading) {
            loading.start();
            faturaService.cancelar(fatura.faturaId, values)
                .then(response => {
                    message.success("Fatura cancelada com sucesso");
                    modal.close();
                    onFaturaCancelada(response);
                })
                .catch(e => {
                    message.handleResponse(e)
                        .badRequest(form.setErrorsFromServer)
                        .showException();
                })
                .finally(loading.stop);
        }
    }, [fatura.faturaId, faturaService, loading, message, modal, onFaturaCancelada]);

    return (
        <JustificativaModal 
            confirmText="Cancelar Fatura"
            disabled={loading.isLoading}
            modal={modal}
            onConfirm={handleConfirm}
            title={`Cancelamento da Fatura ${fatura.faturaId}`}
        />
    )
}